import { render, staticRenderFns } from "./IcDisplay.vue?vue&type=template&id=08870634&scoped=true"
import script from "./IcDisplay.vue?vue&type=script&lang=js"
export * from "./IcDisplay.vue?vue&type=script&lang=js"
import style0 from "./IcDisplay.vue?vue&type=style&index=0&id=08870634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08870634",
  null
  
)

export default component.exports